import { union } from "../../shared/src/codecs/types/union";
import { literal } from "../../shared/src/codecs/types/literal";
import { TTypeOfNewDefault } from "../../shared/src/codecs/codec";
import { overload } from "../../shared/src/codecs/types/overload";
import { intersection } from "../../shared/src/codecs/types/intersection";
import { required } from "../../shared/src/codecs/types/required";
import { boolean } from "../../shared/src/codecs/types/boolean";
import { SellingPropertyState } from "./SellingPropertyState";
import { PaymentMethod } from "./PaymentMethod";

import { HasProvidedConveyancerDetails } from "./HasProvidedConveyancerDetails";
import { HasProvidedProofOfFundsForOffer } from "./HasProvidedProofOfFundsForOffer";
import { HasProvidedMortgageBrokerDetails } from "./HasProvidedMortgageBrokerDetails";
import { requiredFlatOverloaded } from "../../shared/src/codecs/types/requiredFlatOverloaded";
import { calculateRiskPoints, riskFromPoints } from "../models/ScoringPoints";

const RiskOfFallThrough1 = union([literal("low"), literal("medium"), literal("high")]);

export type TRiskOfFallThrough1NewDfault = TTypeOfNewDefault<typeof RiskOfFallThrough1>;

export const RiskOfFallThrough2 = overload(
    RiskOfFallThrough1,
    intersection([
        required({
            selling_property_state: SellingPropertyState,
            conveyancer_confirmed_timeframe: boolean(),
            payment_method: PaymentMethod,
            mortgage_broker_has_vouched: boolean(),
        }),
        requiredFlatOverloaded({
            has_provided_conveyancer_details: HasProvidedConveyancerDetails,
            has_provided_proof_of_funds: HasProvidedProofOfFundsForOffer,
            has_provided_mortgage_broker_details: HasProvidedMortgageBrokerDetails,
        }),
    ]),
    (details) => riskFromPoints(calculateRiskPoints({
        has_provided_conveyancer_details: details.has_provided_conveyancer_details,
        conveyancer_confirmed_timeframe: details.conveyancer_confirmed_timeframe,
        selling_property_state: details.selling_property_state,
        has_provided_proof_of_funds: details.has_provided_proof_of_funds,
        payment_method: details.payment_method,
        mortgage_broker_has_vouched: details.mortgage_broker_has_vouched,
        has_provided_mortgage_broker_details: details.has_provided_mortgage_broker_details,
    })),
);
